import styled, { keyframes, css } from "styled-components";

const delayTimer = 5;
const modalWidth = 300;

export const Container = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    borderRadius: theme.spacing.large,
    background: theme.colors[theme.colorMode].background_Primary,
    minWidth: `${modalWidth}px`,
    position: "relative",
    transform: "translate3d(0, 0, 0)",
    overflow: "hidden",
}));

export const ContentContainer = styled.div(({ theme: _theme }) => ({
    textAlign: "center",
    position: "relative",
}));

export const ImageContainer = styled.div({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 auto",
});

export const StyledCloseIcon = styled.div(({ theme }) => ({
    position: "absolute",
    top: theme.spacing.small,
    right: theme.spacing.small,
    zIndex: 1,
}));

export const ButtonCTA = styled.div(({ theme }) => ({
    marginTop: theme.spacing.medium,
    marginBottom: theme.spacing.large,
    textTransform: "uppercase",
    background: "transparent",
    cursor: "pointer",
    textAlign: "center",
}));

const roundtime = keyframes`
  to {
    transform: scaleX(0);
  }
`;

export const TimerContainer = styled.div(
    ({ theme }) => css`
        height: 6px;
        background: ${theme.colors[theme.colorMode].primary};
        border-radius: ${theme.spacing.small};
        transform-origin: right center;
        animation: ${roundtime} ${delayTimer}s linear forwards;
    `,
);
